import { useQueryClient } from '@tanstack/react-query';

import { withLimitToBE } from '@/react/hooks/useLimitToBE';
import { queryKeys } from '@/react/portainer/environments/update-schedules/queries/query-keys';
import { BetaAlert } from '@/react/portainer/environments/update-schedules/common/BetaAlert';

import { PageHeader } from '@@/PageHeader';

import { UpdateSchedulesDatatable } from './UpdateSchedulesDatatable';

export default withLimitToBE(ListView);

export function ListView() {
  const queryClient = useQueryClient();
  return (
    <>
      <PageHeader
        title="Update & Rollback"
        breadcrumbs="Update and rollback"
        reload
        onReload={() => queryClient.invalidateQueries(queryKeys.base())}
      />

      <BetaAlert
        className="mb-2 ml-[15px]"
        message="Beta feature - currently limited to standalone Linux edge devices."
      />

      <UpdateSchedulesDatatable />
    </>
  );
}
